class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick =
      this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');

    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        const target = event.target;

        if (
          target.closest('price-range') ||
          target.matches('.field__input[name*="price"]') ||
          target.matches('input[name*="filter.v.price"]')
        ) {
          return;
        }

        this.debouncedOnSubmit(event);
      });

      facetForm.addEventListener('change', (event) => {
        const target = event.target;

        if (
          target.closest('price-range') ||
          target.matches('.field__input[name*="price"]') ||
          target.matches('input[name*="filter.v.price"]')
        ) {
          this.onSubmitHandler(event);
        }
      });
    }

    const facetWrapper =
      this.querySelector('#FacetsWrapperDesktop');

    if (facetWrapper) {
      facetWrapper.addEventListener(
        'keyup',
        onKeyUpEscape
      );
    }

    const facetButton =
      this.querySelector('.facets__button-show');

    if (facetButton) {
      facetButton.onclick = (event) => {
        event.currentTarget
          .querySelector('.label-hide')
          .classList.toggle('hidden');

        event.currentTarget
          .querySelector('.label-show')
          .classList.toggle('hidden');

        if (
          !event.currentTarget.classList.contains(
            'facets__button-show_up'
          )
        ) {
          if (
            event.currentTarget
              .querySelector('.label-hide')
              .classList.contains('hidden')
          ) {
            const container =
              this.querySelector('.facets__container');

            if (container) {
              const width =
                container.offsetWidth + 32;

              container.classList.add('hide');

              container.style.marginLeft =
                `-${width + 64}px`;

              const productsGrid =
                document.querySelector(
                  '.products-grid'
                );

              const facetsTop =
                document.querySelector(
                  '.facets__top'
                );

              if (productsGrid) {
                productsGrid.style.marginLeft =
                  `-${width}px`;
              }

              if (facetsTop) {
                facetsTop.style.marginLeft =
                  `-${width}px`;
              }
            }
          } else {
            const container =
              this.querySelector('.facets__container');

            if (container) {
              container.classList.remove('hide');
              container.style.marginLeft = '0';
            }

            const productsGrid =
              document.querySelector(
                '.products-grid'
              );

            const facetsTop =
              document.querySelector(
                '.facets__top'
              );

            if (productsGrid) {
              productsGrid.style.marginLeft = '0';
            }

            if (facetsTop) {
              facetsTop.style.marginLeft = '0';
            }
          }

          const productsGrid =
            document.querySelector(
              '.products-grid'
            );

          if (productsGrid) {
            productsGrid.classList.toggle(
              'full-width'
            );
          }

          const collectionResults =
            document.querySelector(
              '.collection-results'
            );

          if (collectionResults) {
            collectionResults.classList.toggle(
              'full-width'
            );
          }
        } else {
          const container =
            this.querySelector(
              '.facets__container'
            );

          const wrapper =
            this.querySelector(
              '.facets__wrapper'
            );

          if (
            event.currentTarget
              .querySelector('.label-hide')
              .classList.contains('hidden')
          ) {
            if (container && wrapper) {
              const height =
                container.offsetHeight;

              wrapper.style.marginTop =
                `-${height}px`;
            }
          } else if (wrapper) {
            wrapper.style.marginTop = '0';
          }
        }
      };

      const collectionGridSection =
        document.querySelector(
          '.collection-grid-section'
        ) ||
        document.querySelector(
          '.section-search'
        );

      let prevWidth = 0;

      if (
        collectionGridSection &&
        typeof ResizeObserver !== 'undefined'
      ) {
        const sectionResizeObserver =
          new ResizeObserver((entries) => {
            const [entry] = entries;

            if (
              !facetButton.classList.contains(
                'facets__button-show_up'
              ) &&
              entry.contentRect.width !==
                prevWidth
            ) {
              if (
                facetButton
                  .querySelector('.label-hide')
                  .classList.contains('hidden')
              ) {
                if (
                  entry.contentRect.width >
                  749
                ) {
                  const container =
                    this.querySelector(
                      '.facets__container'
                    );

                  if (container) {
                    const width =
                      container.offsetWidth +
                      32;

                    container.classList.add(
                      'hide'
                    );

                    container.style.marginLeft =
                      `-${width + 64}px`;

                    const productsGrid =
                      document.querySelector(
                        '.products-grid'
                      );

                    const facetsTop =
                      document.querySelector(
                        '.facets__top'
                      );

                    if (productsGrid) {
                      productsGrid.style.marginLeft =
                        `-${width}px`;
                    }

                    if (facetsTop) {
                      facetsTop.style.marginLeft =
                        `-${width}px`;
                    }
                  }
                } else {
                  const container =
                    this.querySelector(
                      '.facets__container'
                    );

                  if (container) {
                    container.classList.remove(
                      'hide'
                    );

                    container.style.marginLeft =
                      '0';
                  }

                  const productsGrid =
                    document.querySelector(
                      '.products-grid'
                    );

                  const facetsTop =
                    document.querySelector(
                      '.facets__top'
                    );

                  if (productsGrid) {
                    productsGrid.style.marginLeft =
                      '0';
                  }

                  if (facetsTop) {
                    facetsTop.style.marginLeft =
                      '0';
                  }
                }
              }
            } else {
              if (
                facetButton
                  .querySelector('.label-hide')
                  .classList.contains('hidden') &&
                entry.contentRect.width !==
                  prevWidth
              ) {
                if (
                  entry.contentRect.width >
                  749
                ) {
                  const wrapper =
                    this.querySelector(
                      '.facets__wrapper'
                    );

                  if (wrapper) {
                    const height =
                      wrapper.offsetHeight;

                    wrapper.style.marginTop =
                      `-${height}px`;
                  }

                  prevWidth =
                    entry.contentRect.width;
                } else {
                  const wrapper =
                    this.querySelector(
                      '.facets__wrapper'
                    );

                  if (wrapper) {
                    wrapper.style.marginTop =
                      '0';
                  }
                }
              }
            }
          });

        sectionResizeObserver.observe(
          collectionGridSection
        );
      }
    }

    document.addEventListener('click', (e) => {
      const detailsList =
        document.querySelectorAll(
          '.facets__wrapper--horizontal .facets__disclosure'
        );

      const details =
        e.target.closest(
          '.facets__disclosure[open]'
        );

      if (!details && detailsList) {
        detailsList.forEach((item) => {
          item.removeAttribute('open');
        });
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (
        searchParams ===
        FacetFiltersForm.searchParamsPrev
      ) {
        return;
      }

      FacetFiltersForm.renderPage(
        searchParams,
        null,
        false
      );
    };

    window.addEventListener(
      'popstate',
      onHistoryChange
    );
  }

  static toggleActiveFacets(
    disable = true
  ) {
    document
      .querySelectorAll('.js-facet-remove')
      .forEach((element) => {
        element.classList.toggle(
          'disabled',
          disable
        );
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true
  ) {
    FacetFiltersForm.searchParamsPrev =
      searchParams;

    const sections =
      FacetFiltersForm.getSections();

    const countContainer =
      document.getElementById(
        'ProductCount'
      );

    const countContainerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    const productGridContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    if (productGridContainer) {
      const collection =
        productGridContainer.querySelector(
          '.collection'
        );

      if (collection) {
        collection.classList.add(
          'loading'
        );
      }
    }

    if (countContainer) {
      countContainer.classList.add(
        'loading'
      );
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add(
        'loading'
      );
    }

    sections.forEach((section) => {
      const url =
        `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl =
        (element) =>
          element.url === url;

      if (
        FacetFiltersForm.filterData.some(
          filterDataUrl
        )
      ) {
        FacetFiltersForm.renderSectionFromCache(
          filterDataUrl,
          event
        );
      } else {
        FacetFiltersForm.renderSectionFromFetch(
          url,
          event
        );
      }
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(
        searchParams
      );
    }
  }

  static renderSectionFromFetch(
    url,
    event
  ) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url
          }
        ];

        FacetFiltersForm.renderFilters(
          html,
          event
        );

        FacetFiltersForm.renderProductGridContainer(
          html
        );

        FacetFiltersForm.renderProductCount(
          html
        );
      })
      .catch((error) => {
        console.error(
          'Facet filtering error:',
          error
        );
      });
  }

  static renderSectionFromCache(
    filterDataUrl,
    event
  ) {
    const cachedData =
      FacetFiltersForm.filterData.find(
        filterDataUrl
      );

    if (!cachedData) {
      return;
    }

    const html = cachedData.html;

    FacetFiltersForm.renderFilters(
      html,
      event
    );

    FacetFiltersForm.renderProductGridContainer(
      html
    );

    FacetFiltersForm.renderProductCount(
      html
    );
  }

  static renderProductGridContainer(
    html
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const newProductGrid =
      parsedHTML.getElementById(
        'ProductGridContainer'
      );

    const productGridContainer =
      document.getElementById(
        'ProductGridContainer'
      );

    if (
      newProductGrid &&
      productGridContainer
    ) {
      productGridContainer.innerHTML =
        newProductGrid.innerHTML;
    }

    if (
      document.querySelector(
        '.js-load-more'
      ) ||
      document.querySelector(
        '.js-infinite-scroll'
      )
    ) {
      loadMore();
    }

    if (typeof colorSwatches === 'function') {
      colorSwatches();
    }

    PriceRange.refreshAll();
  }

  static renderProductCount(
    html
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const newCount =
      parsedHTML.getElementById(
        'ProductCount'
      );

    const container =
      document.getElementById(
        'ProductCount'
      );

    const containerDesktop =
      document.getElementById(
        'ProductCountDesktop'
      );

    if (
      newCount &&
      container
    ) {
      container.innerHTML =
        newCount.innerHTML;

      container.classList.remove(
        'loading'
      );
    }

    if (
      newCount &&
      containerDesktop
    ) {
      containerDesktop.innerHTML =
        newCount.innerHTML;

      containerDesktop.classList.remove(
        'loading'
      );
    }
  }

  static renderFilters(
    html,
    event
  ) {
    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const facetDetailsElements =
      parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, ' +
        '#FacetFiltersFormMobile .js-filter, ' +
        '#FacetFiltersPillsForm .js-filter'
      );

    const matchesIndex = (element) => {
      const jsFilter =
        event
          ? event.target.closest(
              '.js-filter'
            )
          : undefined;

      return jsFilter
        ? element.dataset.index ===
            jsFilter.dataset.index
        : false;
    };

    const facetsToRender =
      Array.from(
        facetDetailsElements
      ).filter(
        (element) =>
          !matchesIndex(element)
      );

    const countsToRender =
      Array.from(
        facetDetailsElements
      ).find(matchesIndex);

    facetsToRender.forEach(
      (element) => {
        const target =
          document.querySelector(
            `.js-filter[data-index="${element.dataset.index}"]`
          );

        if (target) {
          target.innerHTML =
            element.innerHTML;
        }
      }
    );

    FacetFiltersForm.renderActiveFacets(
      parsedHTML
    );

    FacetFiltersForm.renderAdditionalElements(
      parsedHTML
    );

    if (
      countsToRender &&
      event
    ) {
      const target =
        event.target.closest(
          '.js-filter'
        );

      if (target) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          target
        );
      }
    }

    PriceRange.refreshAll();
  }

  static renderActiveFacets(
    html
  ) {
    const selectors = [
      '.active-facets-mobile',
      '.active-facets-desktop'
    ];

    selectors.forEach(
      (selector) => {
        const activeFacetsElement =
          html.querySelector(selector);

        if (!activeFacetsElement) {
          return;
        }

        const currentElement =
          document.querySelector(
            selector
          );

        if (currentElement) {
          currentElement.innerHTML =
            activeFacetsElement.innerHTML;
        }
      }
    );

    FacetFiltersForm.toggleActiveFacets(
      false
    );
  }

  static renderAdditionalElements(
    html
  ) {
    const selectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting'
    ];

    selectors.forEach(
      (selector) => {
        const source =
          html.querySelector(selector);

        const target =
          document.querySelector(selector);

        if (
          !source ||
          !target
        ) {
          return;
        }

        target.innerHTML =
          source.innerHTML;
      }
    );

    const mobileForm =
      document.getElementById(
        'FacetFiltersFormMobile'
      );

    if (
      mobileForm &&
      mobileForm.closest('menu-drawer')
    ) {
      mobileForm
        .closest('menu-drawer')
        .bindEvents();
    }
  }

  static renderCounts(
    source,
    target
  ) {
    const targetElement =
      target.querySelector(
        '.facets__selected'
      );

    const sourceElement =
      source.querySelector(
        '.facets__selected'
      );

    const targetElementAccessibility =
      target.querySelector(
        '.facets__summary'
      );

    const sourceElementAccessibility =
      source.querySelector(
        '.facets__summary'
      );

    if (
      sourceElement &&
      targetElement
    ) {
      targetElement.outerHTML =
        sourceElement.outerHTML;
    }

    if (
      targetElementAccessibility &&
      sourceElementAccessibility
    ) {
      targetElementAccessibility.outerHTML =
        sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(
    searchParams
  ) {
    history.pushState(
      {
        searchParams
      },
      '',
      `${window.location.pathname}${
        searchParams
          ? '?' + searchParams
          : ''
      }`
    );
  }

  static getSections() {
    const productGrid =
      document.getElementById(
        'product-grid'
      );

    if (!productGrid) {
      return [];
    }

    return [
      {
        section:
          productGrid.dataset.id
      }
    ];
  }

  createSearchParams(form) {
    const formData =
      new FormData(form);

    return new URLSearchParams(
      formData
    ).toString();
  }

  onSubmitForm(
    searchParams,
    event
  ) {
    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms =
      document.querySelectorAll(
        'facet-filters-form form'
      );

    if (
      event.srcElement &&
      event.srcElement.className ===
        'mobile-facets__checkbox'
    ) {
      const form =
        event.target.closest('form');

      if (form) {
        const searchParams =
          this.createSearchParams(
            form
          );

        this.onSubmitForm(
          searchParams,
          event
        );
      }

      return;
    }

    const forms = [];

    const currentForm =
      event.target.closest('form');

    if (!currentForm) {
      return;
    }

    const isMobile =
      currentForm.id ===
      'FacetFiltersFormMobile';

    sortFilterForms.forEach(
      (form) => {
        if (!isMobile) {
          if (
            form.id ===
              'FacetSortForm' ||
            form.id ===
              'FacetFiltersForm' ||
            form.id ===
              'FacetSortDrawerForm'
          ) {
            const noJsElements =
              document.querySelectorAll(
                '.no-js-list'
              );

            noJsElements.forEach(
              (el) => el.remove()
            );

            forms.push(
              this.createSearchParams(
                form
              )
            );
          }
        } else if (
          form.id ===
          'FacetFiltersFormMobile'
        ) {
          forms.push(
            this.createSearchParams(
              form
            )
          );
        }
      }
    );

    this.onSubmitForm(
      forms.join('&'),
      event
    );
  }

  onActiveFilterClick(
    event
  ) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const url =
      event.currentTarget.href.indexOf(
        '?'
      ) === -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf(
              '?'
            ) + 1
          );

    FacetFiltersForm.renderPage(
      url
    );
  }
}

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);

FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minInput =
      this.querySelectorAll('input')[0];

    this.maxInput =
      this.querySelectorAll('input')[1];

    if (
      !this.minInput ||
      !this.maxInput
    ) {
      return;
    }

    this.storeOriginalLimits();
    this.bindNumberInputs();
    this.bindRangeInputs();
    this.setMinAndMaxValues();
    this.syncSliders();
    this.fillSlider();
  }

  storeOriginalLimits() {
    if (
      !this.minInput.hasAttribute(
        'data-original-min'
      )
    ) {
      this.minInput.setAttribute(
        'data-original-min',
        this.minInput.getAttribute(
          'min'
        ) || '0'
      );
    }

    if (
      !this.minInput.hasAttribute(
        'data-original-max'
      )
    ) {
      this.minInput.setAttribute(
        'data-original-max',
        this.minInput.getAttribute(
          'max'
        ) || ''
      );
    }

    if (
      !this.maxInput.hasAttribute(
        'data-original-min'
      )
    ) {
      this.maxInput.setAttribute(
        'data-original-min',
        this.maxInput.getAttribute(
          'min'
        ) || '0'
      );
    }

    if (
      !this.maxInput.hasAttribute(
        'data-original-max'
      )
    ) {
      this.maxInput.setAttribute(
        'data-original-max',
        this.maxInput.getAttribute(
          'max'
        ) || ''
      );
    }
  }

  bindNumberInputs() {
    this.minInput.addEventListener(
      'input',
      () => {
        /*
         * ONLY clean the characters.
         * Do NOT change the value,
         * compare it with the other field,
         * or submit the form here.
         */
        this.minInput.value =
          this.minInput.value.replace(
            /[^\d]/g,
            ''
          );

        this.syncSlidersFromInputs();
        this.fillSlider();
      }
    );

    this.maxInput.addEventListener(
      'input',
      () => {
        /*
         * The user can completely erase
         * the existing value here.
         */
        this.maxInput.value =
          this.maxInput.value.replace(
            /[^\d]/g,
            ''
          );

        this.syncSlidersFromInputs();
        this.fillSlider();
      }
    );

    this.minInput.addEventListener(
      'change',
      () => {
        this.finishNumberInput(
          this.minInput
        );
      }
    );

    this.maxInput.addEventListener(
      'change',
      () => {
        this.finishNumberInput(
          this.maxInput
        );
      }
    );
  }

  finishNumberInput(
    input
  ) {
    if (!input) {
      return;
    }

    /*
     * Empty is valid while editing.
     */
    if (
      input.value === ''
    ) {
      this.setMinAndMaxValues();
      this.syncSlidersFromInputs();
      this.fillSlider();
      return;
    }

    let value =
      Number(input.value);

    if (
      !Number.isFinite(value)
    ) {
      input.value = '';
      return;
    }

    const originalMin =
      Number(
        input.getAttribute(
          'data-original-min'
        )
      );

    const originalMaxAttribute =
      input.getAttribute(
        'data-original-max'
      );

    const originalMax =
      originalMaxAttribute !== null &&
      originalMaxAttribute !== ''
        ? Number(
            originalMaxAttribute
          )
        : null;

    if (
      Number.isFinite(
        originalMin
      ) &&
      value < originalMin
    ) {
      value = originalMin;
    }

    if (
      originalMax !== null &&
      Number.isFinite(
        originalMax
      ) &&
      value > originalMax
    ) {
      value = originalMax;
    }

    input.value = value;

    const minValue =
      this.minInput.value !== ''
        ? Number(
            this.minInput.value
          )
        : null;

    const maxValue =
      this.maxInput.value !== ''
        ? Number(
            this.maxInput.value
          )
        : null;

    /*
     * Only compare the two fields
     * AFTER editing has finished.
     */
    if (
      minValue !== null &&
      maxValue !== null &&
      Number.isFinite(minValue) &&
      Number.isFinite(maxValue) &&
      minValue > maxValue
    ) {
      if (
        input === this.minInput
      ) {
        this.minInput.value =
          maxValue;
      } else {
        this.maxInput.value =
          minValue;
      }
    }

    this.setMinAndMaxValues();
    this.syncSlidersFromInputs();
    this.fillSlider();
  }

  bindRangeInputs() {
    const ranges =
      this.querySelectorAll(
        '.field__range'
      );

    if (
      ranges.length < 2
    ) {
      return;
    }

    const rangeFrom =
      ranges[0];

    const rangeTo =
      ranges[1];

    rangeFrom.addEventListener(
      'input',
      () => {
        let from =
          Number(
            rangeFrom.value
          );

        let to =
          Number(
            rangeTo.value
          );

        if (
          from > to
        ) {
          from = to;
          rangeFrom.value =
            from;
        }

        this.minInput.value =
          from;

        this.setMinAndMaxValues();
        this.fillSlider();
      }
    );

    rangeTo.addEventListener(
      'input',
      () => {
        let from =
          Number(
            rangeFrom.value
          );

        let to =
          Number(
            rangeTo.value
          );

        if (
          to < from
        ) {
          to = from;
          rangeTo.value =
            to;
        }

        this.maxInput.value =
          to;

        this.setMinAndMaxValues();
        this.fillSlider();

        if (
          Number(
            rangeTo.value
          ) <= 0
        ) {
          rangeTo.style.zIndex =
            2;
        } else {
          rangeTo.style.zIndex =
            0;
        }
      }
    );
  }

  setMinAndMaxValues() {
    if (
      !this.minInput ||
      !this.maxInput
    ) {
      return;
    }

    const minValue =
      this.minInput.value !== ''
        ? Number(
            this.minInput.value
          )
        : null;

    const maxValue =
      this.maxInput.value !== ''
        ? Number(
            this.maxInput.value
          )
        : null;

    const originalMin =
      this.minInput.getAttribute(
        'data-original-min'
      ) || '0';

    const originalMax =
      this.maxInput.getAttribute(
        'data-original-max'
      ) || '';

    /*
     * These limits change only according
     * to an existing value.
     *
     * They never put a value back into
     * the actual input.
     */
    if (
      maxValue !== null &&
      Number.isFinite(maxValue)
    ) {
      this.minInput.setAttribute(
        'max',
        maxValue
      );
    } else {
      this.minInput.setAttribute(
        'max',
        originalMax
      );
    }

    if (
      minValue !== null &&
      Number.isFinite(minValue)
    ) {
      this.maxInput.setAttribute(
        'min',
        minValue
      );
    } else {
      this.maxInput.setAttribute(
        'min',
        originalMin
      );
    }
  }

  syncSlidersFromInputs() {
    const ranges =
      this.querySelectorAll(
        '.field__range'
      );

    if (
      ranges.length < 2
    ) {
      return;
    }

    const rangeFrom =
      ranges[0];

    const rangeTo =
      ranges[1];

    if (
      this.minInput.value !== ''
    ) {
      const minValue =
        Number(
          this.minInput.value
        );

      if (
        Number.isFinite(
          minValue
        )
      ) {
        rangeFrom.value =
          minValue;
      }
    }

    if (
      this.maxInput.value !== ''
    ) {
      const maxValue =
        Number(
          this.maxInput.value
        );

      if (
        Number.isFinite(
          maxValue
        )
      ) {
        rangeTo.value =
          maxValue;
      }
    }
  }

  syncSliders() {
    const ranges =
      this.querySelectorAll(
        '.field__range'
      );

    if (
      ranges.length < 2
    ) {
      return;
    }

    const rangeFrom =
      ranges[0];

    const rangeTo =
      ranges[1];

    if (
      this.minInput.value !== ''
    ) {
      const minValue =
        Number(
          this.minInput.value
        );

      if (
        Number.isFinite(
          minValue
        )
      ) {
        rangeFrom.value =
          minValue;
      }
    }

    if (
      this.maxInput.value !== ''
    ) {
      const maxValue =
        Number(
          this.maxInput.value
        );

      if (
        Number.isFinite(
          maxValue
        )
      ) {
        rangeTo.value =
          maxValue;
      }
    }
  }

  fillSlider() {
    const wrappers =
      this.querySelectorAll(
        '.facets__range'
      );

    wrappers.forEach(
      (wrapper) => {
        const ranges =
          wrapper.querySelectorAll(
            '.field__range'
          );

        if (
          ranges.length < 2
        ) {
          return;
        }

        const from =
          ranges[0];

        const to =
          ranges[1];

        const min =
          Number(to.min);

        const max =
          Number(to.max);

        if (
          !Number.isFinite(min) ||
          !Number.isFinite(max) ||
          max <= min
        ) {
          return;
        }

        let fromValue =
          Number(from.value);

        let toValue =
          Number(to.value);

        if (
          !Number.isFinite(
            fromValue
          )
        ) {
          fromValue = min;
        }

        if (
          !Number.isFinite(
            toValue
          )
        ) {
          toValue = max;
        }

        fromValue =
          Math.max(
            min,
            Math.min(
              max,
              fromValue
            )
          );

        toValue =
          Math.max(
            min,
            Math.min(
              max,
              toValue
            )
          );

        if (
          fromValue > toValue
        ) {
          fromValue =
            toValue;
        }

        const range =
          max - min;

        const minRange =
          ((fromValue - min) /
            range) *
          100;

        const maxRange =
          ((toValue - min) /
            range) *
          100;

        wrapper.style.setProperty(
          '--range-min',
          `${minRange}%`
        );

        wrapper.style.setProperty(
          '--range-max',
          `${maxRange}%`
        );
      }
    );
  }

  static refreshAll() {
    document
      .querySelectorAll(
        'price-range'
      )
      .forEach(
        (element) => {
          if (
            element instanceof
            PriceRange
          ) {
            element.refresh();
          }
        }
      );
  }

  refresh() {
    const inputs =
      this.querySelectorAll(
        'input'
      );

    if (
      inputs.length < 2
    ) {
      return;
    }

    this.minInput =
      inputs[0];

    this.maxInput =
      inputs[1];

    this.storeOriginalLimits();
    this.setMinAndMaxValues();
    this.syncSliders();
    this.fillSlider();
  }
}

customElements.define(
  'price-range',
  PriceRange
);


class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink =
      this.querySelector('a');

    if (!facetLink) {
      return;
    }

    facetLink.setAttribute(
      'role',
      'button'
    );

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(this)
    );

    facetLink.addEventListener(
      'keyup',
      (event) => {
        event.preventDefault();

        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          this.closeFilter(
            event
          );
        }
      }
    );
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest(
        'facet-filters-form'
      ) ||
      document.querySelector(
        'facet-filters-form'
      );

    if (form) {
      form.onActiveFilterClick(
        event
      );
    }
  }
}

customElements.define(
  'facet-remove',
  FacetRemove
);